'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ifElse(predicate, affimative, negative, subject) {
  if (predicate(subject)) {
    return affimative(subject);
  }
  return negative(subject);
}

/**
 * Applies `affirmative` to `subject` if `predicate(subject)` is truthy.
 * Otherwise applies `negative` to `subject`.
 *
 * @example
 * const incrementAwayFromZero = ifElse(
 *   n => n >= 0,
 *   n => n + 1,
 *   n => n - 1
 * );
 *
 * incrementAwayFromZero(1) === 2
 * incrementAwayFromZero(-1) === -2
 *
 * @param {Function} predicate
 * @param {Function} affirmative
 * @param {Function} negative
 * @param {any} subject
 * @return {any}
 */
exports.default = (0, _curry2.default)(ifElse);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/ifElse.js
// module id = 176
// module chunks = 0 1